import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrderExportNavModule } from './extensions/e658fd0bde74fa298ee9a7492671dac4a1048c54b6691a31393350ff50eb0fec/order-export-nav.module';
import { OrderExportActionModule } from './extensions/e658fd0bde74fa298ee9a7492671dac4a1048c54b6691a31393350ff50eb0fec/order-export-action.module';
import { StopOrderDetailModule } from './extensions/b71788b115335e9986f70a6171e4eef323843ca4a9168bfbba6bc9ca8260bcd9/stop.module';
import { OrderNotesWidgetModule } from './extensions/9060ad625eb01f6cca8669808b43f18c5195f43459961a412002c6ea87804ba3/order-notes-widget.module';
import { BundleVariantDetailModule } from './extensions/90bbbdc3e61c9be112105465d6efdbaa4dd1bf9df18c056372cdb6f27c1907e4/bundle-variant-detail.module';

import SharedProviders_3_0 from './extensions/2d2adbd2107b6543bdcadbcc5948e2687d3284fd7e19fcaf2a6fad22ec8e02e1/providers';
import SharedProviders_4_0 from './extensions/delivery-widget-ui/providers';
import SharedProviders_5_0 from './extensions/missed-deliveries-widget-ui/providers';
import SharedProviders_6_0 from './extensions/e869b0f89a96054eee4f2637d74450dfa5b0e588b4baf2b7b51ade80a2bb1faa/providers';
import SharedProviders_8_0 from './extensions/gift-plugin/providers';


@NgModule({
    imports: [CommonModule, OrderExportNavModule, OrderExportActionModule, StopOrderDetailModule, OrderNotesWidgetModule, BundleVariantDetailModule],
    providers: [...SharedProviders_3_0, ...SharedProviders_4_0, ...SharedProviders_5_0, ...SharedProviders_6_0, ...SharedProviders_8_0],
})
export class SharedExtensionsModule {}
